import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { auth } from '../firebase'
import { AdminLayout } from './AdminLayout'

/**
 * Legacy admin Layout — now a thin wrapper around AdminLayout so every
 * admin page shares the same minimalist sidebar, top bar, and styling.
 */
export function Layout({ children }) {
  const { user } = useAuth()
  const navigate = useNavigate()

  const handleLogout = () => {
    auth.signOut().then(() => navigate('/login'))
  }

  return (
    <AdminLayout user={user} onLogout={handleLogout}>
      {children}
    </AdminLayout>
  )
}
